import { isAfter, isBefore } from "date-fns";

export const riskMenuItems = [
    {
        value: '',
        // label: 'All at-risk units',
        label: 'All units',
    },
    {
        value: 'Expiring within 5 years',
        label: 'Expiring in 3 to 5 years',
    },
    {
        value: 'Expiring within 3 years',
        label: 'Expiring in 1 to 3 years',
    },
    {
        value: 'Expiring within 1 year',
        label: 'Expiring in 6 months to a year',
    },
    {
        value: 'Expiring within 6 months',
        label: 'Expiring within 6 months',
    },
];

export const amiMenuItems = [
    {
        value: '',
        label: 'All AMI',
    },
    {
        value: 30,
        label: '30%',
    },
    {
        value: 50,
        label: '50%',
    },
    {
        value: 60,
        label: '60%',
    },
    {
        value: 80,
        label: '80%',
    },
    {
        value: 100,
        label: '100%',
    },
    {
        value: 115,
        label: '115%',
    },
    {
        value: 120,
        label: '120%',
    },
];

export const fundingMenuItems = [
    {
        value: '',
        label: 'All funding sources',
    },
    {
        value: 'Section 8',
        label: 'Section 8',
    },
    {
        value: 'LIHTC',
        label: 'LIHTC',
    },
    {
        value: 'HOME',
        label: 'HOME',
    },
    {
       value: 'HomeFlex',
       label: 'HomeFlex'
    },
    {
        value: 'NSP',
        label: 'NSP',
    },
    {
        value: 'Inclusionary Zoning',
        label: 'Inclusionary Zoning',
    },
    {
        value: 'Exchange',
        label: 'Exchange',
    },
    {
        value: 'HomeFirst',
        label: 'HomeFirst',
    },
    {
        value: 'Lease Purchase Bonds',
        label: 'Lease Purchase Bonds',
    },
    {
        value: 'Beltline Affordable Housing Trust Fund',
        label: 'Beltline Affordable Housing Trust Fund',
    },
    {
        value: 'Tax Exempt Bond',
        label: 'Tax Exempt Bond',
    },
    {
        value: ['AH Subsidy', 'AH Development'],
        label: 'Atlanta Housing',
    },
    // {
    //     value: 'Eastside TAD',
    //     label: 'Eastside TAD',
    // },
    // {
    //     value: 'Campbellton Road TAD',
    //     label: 'Campbellton Road TAD',
    // },
    // {
    //     value: 'ML King Hollowell TAD',
    //     label: 'ML King Hollowell TAD',
    // },
    // {
    //     value: 'Campbellton Lakewood TAD',
    //     label: 'Campbellton Lakewood TAD',
    // },
    {
        value: 'Vine City Trust Fund',
        label: 'Vine City Trust Fund',
    },
    {
        value: 'Homeless Opportunity Funds',
        label: 'Homeless Opportunity Funds',
    },
    {
        value: 'Downtown Development Authority Revenue Bonds',
        label: 'Downtown Development Authority Revenue Bonds',
    },
    {
        value: 'TAD',
        label: 'Tax Allocation District'
    },
    {
        value: 'FDIC',
        label: 'FDIC',
    },
    {
        value: 'Homeless Opportunity Funds - MF',
        label: 'Homeless Opportunity Funds - MF',
    },
    {
        value: 'PSH',
        label: 'PSH',
    },
    {
        value: 'Housing Opportunity Bonds - MF',
        label: 'Housing Opportunity Bonds - MF',
    }
];

export const populationMenuItems = [
    {
        value: '',
        label: 'All target populations',
    },
    {
        value: ['Senior', 'Elderly', "HFOP"],
        label: 'Senior',
    },
    // {
    //     value: 'HFOP',
    //     label: 'HFOP',
    // },
    // {
    //     value: 'Elderly',
    //     label: 'Elderly',
    // },
    {
      value: 'Disabled',
      label: 'Disabled',
    },
    {
        value: 'Family',
        label: 'Family',
    },
    {
        value: 'PSH',
        label: 'PSH',
    },
];

export const housingMenuItems = [
    {
        value: '',
        label: 'All Development types',
    },
    {
        value: 'New Construction',
        label: 'New Construction',
    },
    // {
    //     value: 'Rehab',
    //     label: 'Rehab',
    // },
    // {
    //     value: 'Acquisition/Rehab',
    //     label: 'Acquisition/Rehab',
    // },
    {
        value: 'Rehab',
        label: 'Rehabilitation',
    },
    {
        value: 'Acq',
        label: 'Acquisition',
    }
  ];

export const tenureMenuItems = [
    {
        value: '',
        label: 'All',
    },
    {
        value: 'Ownership',
        label: 'Ownership',
    },
    {
        value: 'Rental',
        label: 'Rental',
    }
];

export const affordabilityThresholdMenuItems = [
    {
        value: '',
        label: 'None',
    },
    {
        value: '30%',
        label: '30%',
    },
    {
        value: '50%',
        label: '50%',
    },
    {
        value: '60%',
        label: '60%',
    },
    {
        value: '80%',
        label: '80%',
    },
    {
        value: '100%',
        label: '100%',
    },
    {
        value: '120%',
        label: '120%',
    },
    {
        value: 'Above 120%',
        label: 'Above 120%',
    }
];

export const afforabilityTermMenuItems = [
    {
        value: '',
        label: 'None',
    },
    {
        value: 'Permanent',
        label: 'Permanent',
    },
    {
        value: 'Greater than 30 years',
        label: 'Greater than 30 years',
    },
    {
        value: '16 to 30 years',
        label: '16 to 30 years',
    },
    {
        value: '15 years or less',
        label: '15 years or less',
    }
];

export const stewardingMenuItems = [
    {
        value: '',
        label: 'All agencies',
    },
    // {
    //     value: 'Invest Atlanta',
    //     label: 'Invest Atlanta',
    // },
    {
        value: 'Georgia Department of Community Affairs',
        label: 'Georgia Department of Community Affairs',
    },
    {
        value: 'Housing and Urban Development',
        label: 'Housing and Urban Development',
    },
    {
        value: 'Atlanta Housing',
        label: 'Atlanta Housing',
    },
    // {
    //     value: 'National Housing Preservation Database',
    //     label: 'National Housing Preservation Database',
    // },
    {
        value: 'City of Atlanta',
        label: 'City of Atlanta',
    },
    // {
    //     value: 'Beltline',
    //     label: 'Beltline',
    // },
];

export const geographyMenuItems = [
    {
        value: '',
        label: 'None',
    },
    // {
    //     value: 'Beltline',
    //     label: 'Beltline',
    // },
    {
        value: 'Census Tract',
        label: 'Census Tract',
    },
    {
        value: 'Council District',
        label: 'Council District',
    },
    {
        value: 'Neighborhood Statistical Area',
        label: 'Neighborhood Statistical Area',
    },
    {
        value: 'NPU',
        label: 'NPU',
    },
    {
        value: 'School District',
        label: 'Elementary School Zones',
    },
    {
        value: 'High School District',
        label: 'High School Zones',
    },
    {
        value: 'TAD',
        label: 'TAD',
    },
];

export const orgMenuItems = [
    {
        value: '',
        label: 'Organization Type',
    },
    {
        value: 'Education',
        label: 'Education',
    },
    {
        value: 'Research',
        label: 'Research',
    },
    {
        value: 'Advocacy',
        label: 'Advocacy',
    },
    {
        value: 'Service Provider',
        label: 'Service Provider',
    },
    {
        value: 'Non-Profit Developer',
        label: 'Non-Profit Developer',
    },
    {
        value: 'For-Profit Developer',
        label: 'For-Profit Developer',
    },
    {
        value: 'Public Housing Authority',
        label: 'Public Housing Authority',
    },
    {
        value: 'Resident Group',
        label: 'Resident Group',
    },
    {
        value: 'Property Manager',
        label: 'Property Manager',
    },
    {
        value: 'Bank',
        label: 'Bank',
    },
    {
        value: 'Investor',
        label: 'Investor',
    },
    {
        value: 'Consultant',
        label: 'Consultant',
    },
    {
        value: 'Business',
        label: 'Business',
    },
    {
        value: 'Government Agency',
        label: 'Government Agency',
    },
    {
        value: 'Other',
        label: 'Other',
    },
];

export const stateMenuItems = [
    {
        value: '',
        label: 'State',
    },
    {
        value: 'Alabama',
        label: 'AL',
    },
    {
        value: 'Alaska',
        label: 'AK',
    },
    {
        value: 'Arizona',
        label: 'AZ',
    },
    {
        value: 'Arkansas',
        label: 'AR',
    },
    {
        value: 'California',
        label: 'CA',
    },
    {
        value: 'Colorado',
        label: 'CO',
    },
    {
        value: 'Connecticut',
        label: 'CT',
    },
    {
        value: 'Delaware',
        label: 'DE',
    },
    {
        value: 'Florida',
        label: 'FL',
    },
    {
        value: 'Georgia',
        label: 'GA',
    },
    {
        value: 'Hawaii',
        label: 'HI',
    },
    {
        value: 'Idaho',
        label: 'ID',
    },
    {
        value: 'Illinois',
        label: 'IL',
    },
    {
        value: 'Indiana',
        label: 'IN',
    },
    {
        value: 'Iowa',
        label: 'IA',
    },
    {
        value: 'Kansas',
        label: 'KS',
    },
    {
        value: 'Kentucky',
        label: 'KY',
    },
    {
        value: 'Louisiana',
        label: 'LA',
    },
    {
        value: 'Maine',
        label: 'ME',
    },
    {
        value: 'Maryland',
        label: 'MD',
    },
    {
        value: 'Massachusetts',
        label: 'MA',
    },
    {
        value: 'Michigan',
        label: 'MI',
    },
    {
        value: 'Minnesota',
        label: 'MN',
    },
    {
        value: 'Mississippi',
        label: 'MS',
    },
    {
        value: 'Missouri',
        label: 'MO',
    },
    {
        value: 'Montana',
        label: 'MT',
    },
    {
        value: 'Nebraska',
        label: 'NE',
    },
    {
        value: 'Nevada',
        label: 'NV',
    },
    {
        value: 'New Hampshire',
        label: 'NH',
    },
    {
        value: 'New Jersey',
        label: 'NJ',
    },
    {
        value: 'New Mexico',
        label: 'NM',
    },
    {
        value: 'New York',
        label: 'NY',
    },
    {
        value: 'North Carolina',
        label: 'NC',
    },
    {
        value: 'North Dakota',
        label: 'ND',
    },
    {
        value: 'Ohio',
        label: 'OH',
    },
    {
        value: 'Oklahoma',
        label: 'OK',
    },
    {
        value: 'Oregon',
        label: 'OR',
    },
    {
        value: 'Pennsylvania',
        label: 'PA',
    },
    {
        value: 'Rhode Island',
        label: 'RI',
    },
    {
        value: 'South Carolina',
        label: 'SC',
    },
    {
        value: 'South Dakota',
        label: 'SD',
    },
    {
        value: 'Tennessee',
        label: 'TN',
    },
    {
        value: 'Texas',
        label: 'TX',
    },
    {
        value: 'Utah',
        label: 'UT',
    },
    {
        value: 'Vermont',
        label: 'VT',
    },
    {
        value: 'Virginia',
        label: 'VA',
    },
    {
        value: 'Washington',
        label: 'WA',
    },
    {
        value: 'West Virginia',
        label: 'WV',
    },
    {
        value: 'Wisconsin',
        label: 'WI',
    },
    {
        value: 'Wyoming',
        label: 'WY',
    },
];

// const FIVE_YEARS = 'Expiring within 5 years';
// const THREE_YEARS = 'Expiring within 3 years';
// const ONE_YEAR = 'Expiring within 1 year';
// const SIX_MONTHS = 'Expiring within 6 months';

/**
 * Compares 2 objects for equality.
 *
 * @param  {Object} obj1: first object
 * @param  {Object} obj2: second object
 * @return {Boolean}
 */
export const objIsEqual = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2)
}

/**
 * Filters an array of objects with multiple criteria.
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
export const handleFiltering = (array, filters) => {
    const propFilters = filters.Property;
    const subFilters = filters.Subsidy;
    const result = filterHighLevel(array, propFilters);
    //console.log(array)
    //console.log(filterLowLevel(result, subFilters))
    return filterLowLevel(result, subFilters);
}

export const handleFilteringPipeline = (array, filters) => {
    // console.log(filters)
    const DropdownFilters = filters.Dropdown;
    const SwitchFilters = filters.Switch;
    const result = filterDropdown(array, DropdownFilters);
    // console.log(result)
    //console.log(filterLowLevel(result, subFilters))
    return filterSwitch(result, SwitchFilters);
}

/**
 * Helper function used in handleFiltering().
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
const filterHighLevel = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
        return filterKeys.every(key => {
            return filterByValues(item.properties[key], filters[key][0], filters[key][1])
        });
    });
}

const filterDropdown = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
        return filterKeys.every(key => {
            if (!filters[key]) return true;

            return filters[key] === item.properties[key]
        });
    });
}

/**
 * Helper function used in handleFiltering().
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
const filterLowLevel = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
        const filteredSubsidyArray = item.properties.subsidies.filter(item2 => {
            return filterKeys.every(key => {
                if (!filters[key]) return true;
                if (key === "SubStart") {
                    return filterByDate(new Date(item2[key]), filters[key][0], filters[key][1])
                }
                if (key === "SubEnd") {
                    return filterByDate(new Date(item2[key]), filters[key][0], filters[key][1])
                }
                // if (key === "RiskUnits") {
                //     return filterByRiskUnits(item2, filters, key)
                // }
                if (key === "Funding") {
                    const filterIsArray = Array.isArray(filters[key]);
                    const fundingString = item2[key].join(',');

                    if (fundingString) {
                      if (!filterIsArray) {
                        return fundingString.search(filters[key]) !== -1
                      } 
                      const booleanArray = []
                      filters[key].forEach(value => booleanArray.push( fundingString.search(value) !== -1))
                      return !filterIsArray ? false : booleanArray.includes(true);
                    }
                    return false;
                  }
                if (key === "UnitAMI") {
                    return filterByAmi(item2, filters, key)
                }
                if (key === "tenantType"){
                    const filterIsArray = Array.isArray(filters[key])
                    // console.log(filters[key]);
                    // console.log(item2[key])
                    if (item2[key]) {
                      if (!filterIsArray) {
                        return item2[key].search(filters[key]) !== -1
                      }
                      const booleanArray = []
                      filters[key].forEach(value => booleanArray.push( item2[key].search(value) !== -1))
                      return !filterIsArray ? false : booleanArray.includes(true);
                    }
                     return false;
                }
                // if (key === "Stewarding"){
                //     let dictFundingAgency = {"LIHTC":"Georgia Department of Community Affairs","HomeFlex":"Atlanta Housing","Section 8":"Housing and Urban Development","Section 202":"Housing and Urban Development","Public Housing":"Atlanta Housing"}
                //     if (item2["Funding"] === "HOME")
                //     {
                //         return filters[key] === item2[key];
                //     }
                //     else{
                //         if (item2["Funding"] in dictFundingAgency){
                //             return filters[key] === dictFundingAgency[item2["Funding"]];
                //         }else{
                //             return false;
                //         }
                        
                //     }
                     
                // }
                return item2[key].search(filters[key]) !== -1;
            })
        })
        return filteredSubsidyArray.length > 0
    })
}

const stringToBloolean = (str) => {
    switch (str.toLowerCase().trim()){
        case "true": return true; 
        case "false": return false;
        default: return false; 
    }
}

const filterSwitch = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
       
        return filterKeys.every(key => {
            if (!filters[key]) return true;

            var itemValue = ""

            if (item.properties[key] === "Yes"){
                itemValue = "TRUE"
            }else{
                itemValue = "FALSE"
            }

            return filters[key] === stringToBloolean(itemValue);
        })
      
    })
}



/**
 * Helper function used in filterLowLevel().
 *
 * @param  {Date} value: the date to compare
 * @param  {Date} begin: the starting date of the range
 * @param  {Date} end: the ending date of the range
 * @return {Boolean}
 */
const filterByDate = (value, begin, end) => {
    if (begin && end) {
        // both have a value
        return isAfter(value, begin) && isBefore(value, end);
    } else if (begin) {
      // console.log(value, begin);
        // there is a value for begin
        return isAfter(value, begin);
    } else if (end) {
        // there is a value for end
        return isBefore(value, end);
    }
    return true;
}

/**
 * Helper function used in filterLowLevel().
 *
 * @param  {Object} item2: the object that contains risk unit values
 * @return {Boolean}
 */

// const filterByRiskUnits = (item2, filters, key) => {
//     if (filters[key] === FIVE_YEARS) {
//         return (item2[key] === FIVE_YEARS)
//             || (item2[key] === THREE_YEARS)
//             || (item2[key] === ONE_YEAR)
//             || (item2[key] === SIX_MONTHS)
//     }
//     if (filters[key] === THREE_YEARS) {
//         return (item2[key] === THREE_YEARS)
//             || (item2[key] === ONE_YEAR)
//             || (item2[key] === SIX_MONTHS)
//     }
//     if (filters[key] === ONE_YEAR) {
//         return (item2[key] === ONE_YEAR)
//             || (item2[key] === SIX_MONTHS)
//     }
//     return (item2[key] === SIX_MONTHS)
// }

/**
 * Helper function used in filterLowLevel().
 *
 * @param  {Object} obj: the object that contains ami values
 * @return {Boolean}
 */
const filterByAmi = (obj, filters, filterKey) => {
    const itemKeys = Object.keys(obj)
    // eslint-disable-next-line no-unused-vars
    for (const itemKey of itemKeys) {
        if (itemKey.startsWith('ami')) {
            if (+(itemKey.split('_')[1]) <= filters[filterKey]) {
                if (!!obj[itemKey]) {
                    return true;
                }
            }
        }
    }
    return false;
}

/**
 * Helper function used in filterHighLevel().
 *
 * @param  {Number} value: the number to compare
 * @param  {Number} min: the starting number of the range
 * @param  {Number} max: the ending number of the range
 * @return {Boolean}
 */
const filterByValues = (value, min, max) => {
    if (min && max) {
        return value > min && value < max
    } else if (min) {
        return value > min;
    } else if (max) {
        return value < max;
    }
    return true;
}

/**
 * Transforms the data shape for use with the data table
 *
 * @param  {Array} dataArray: the raw shape data
 * @return {Array}
 */
export const transformDataForTable = (dataArray) => {
    let result = [];
    dataArray.forEach(item => {
        result = result.concat(flatten(item.properties))
    })
    return result
}

export const transformDataForTablePipeline = (dataArray) => {
    let result = [];
    dataArray.forEach(item => {
        result = result.concat(item.properties)
    })
    return result
}

/**
 * Helper function used in transformDataForTable().
 * Flattens nested objects and returns them in an array
 *
 * @param  {Array} data: the raw data object
 * @return {Array}
 */

//  const flattenPipeline = (data) => {
//     const {
//         Latitude,
//         Longitude,
//         ProjectName,
//         AffordabilityExpiration,
//         AffordabilityTerm_Above30Years,
//         AffordabilityTerm_At15YearsOrLess,
//         AffordabilityTerm_Between16and30Years,
//         AffordabilityTerm_Permanent,
//         AffordabilityThreshold,
//         Affordability_Above120AMI,
//         Affordability_Below30AMI,
//         Affordability_Below50AMI,
//         Affordability_Below60AMI,
//         Affordability_Below80AMI,
//         Affordability_Below100AMI,
//         Affordability_Below120AMI,
//         BIPOC,
//         CLT,
//         CLTUnits,
//         Develoiper_BIPOS,
//         Developer_NPO,
//         Families,
//         ForSaleUnits,
//         FundingSource_Bond,
//         FundingSource_ConventialDebt,
//         FundingSource_ExistingGrant,
//         FundingSource_ExistingPublic,
//         FundingSource_ImpactInvestment,
//         FundingSource_NMTC,
//         FundingSource_NewGrant,
//         FundingSource_NewPublic,
//     } = data;

//     return {
//                 'Project Name': ProjectName,
//                 'Longitude': Longitude,
//                 'Latitude': Latitude,
             
//             }
//  }

const flatten = (data) => {
    const {
        id,
        longitude,
        latitude,
        address,
        // totalSubsidizedUnits,
        totalUnits,
        // totalPercentSubsidized,
        subsidies,
        census_tract,
        neighborhood_statistical_area,
        neighborhood_planning_unit,
        tax_allocation_district,
        city_council_district,
    } = data;
    // console.log(subsidies[0]);
    return subsidies.map(
        ({
            SubStart,
            SubEnd,
            RiskUnits,
            Stewarding,
            UnitsSub,
            ami_30,
            ami_50,
            ami_60,
            ami_80,
            ami_100,
            ami_115,
            ami_120,
            housingType,
            // expired,
            // subsidyPercentSub,
            tenantType,
            Funding,
            project_name,
        }) => (
            
                {
                    'Id': id,
                    'Project Name': project_name,
                    'Address': address,
                    'Longitude': longitude,
                    'Latitude': latitude,
                    'Total Units': totalUnits,
                    // 'Total Subsidized Units at Property': totalSubsidizedUnits,
                    // 'Percent Subsidized Units at Property': totalPercentSubsidized,
                    'Project Subsidy Units': UnitsSub,
                    'Development Type': housingType,
                    'Subsidy Start Date': SubStart,
                    'Subsidy End Date': SubEnd,
                    // 'Funding Source': Funding[0],
                    'Funding Source': Funding.toString(),
                    'At-risk Units': RiskUnits,
                    'Stewarding Agency': Stewarding,
                    'Target Population': tenantType,
                    'AMI 30': ami_30,
                    'AMI 50': ami_50,
                    'AMI 60': ami_60,
                    'AMI 80': ami_80,
                    'AMI 100': ami_100,
                    'AMI 115': ami_115,
                    'AMI 120': ami_120,
                    'Census Tract': census_tract,
                    'Council District': city_council_district,
                    'Neighborhood Statistical Area': neighborhood_statistical_area,
                    'NPU': neighborhood_planning_unit,
                    'TAD': tax_allocation_district,
                }
            )
    )
}

/**
 * Finds a value in an object and return the key.
 * Returns undefined, otherwise.
 *
 * @param  {Object} object: the object to look through
 * @param  {Boolean} value: the value to look for
 * @return {String}
 */
export const getKeyByValue = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
}

/**
 * Gets the selected filters
 *
 * @param  {Object} filters: the filter object to look through
 * @return {Array}
 */
export const getFiltersForTxt = (filters) => {
    const propFilters = filters.Property;
    const subFilters = filters.Subsidy;

    const array = [];

    const propKeys = Object.keys(propFilters);
    propKeys.forEach(key => {
        if (!!propFilters[key][0] && !!propFilters[key][1]) {
            array.push({ [key]: `Between ${propFilters[key][0]} and ${propFilters[key][1]}` })
        } else if (!!propFilters[key][0]) {
            array.push({ [key]: `Between ${propFilters[key][0]} and any count` })
        } else if (!!propFilters[key][1]) {
            array.push({ [key]: `Between any count and ${propFilters[key][1]}` })
        }
    })

    const subKeys = Object.keys(subFilters);
    subKeys.forEach(key => {
        if (typeof subFilters[key] !== 'object') {
            if (!!subFilters[key]) {
                array.push({ [key]: subFilters[key] })
            }
        } else {
            if (!!subFilters[key][0] && !!subFilters[key][1]) {
                array.push({ [key]: `Between ${(subFilters[key][0]).toLocaleDateString()} and ${(subFilters[key][1]).toLocaleDateString()}` })
            } else if (!!subFilters[key][0]) {
                array.push({ [key]: `Between ${(subFilters[key][0]).toLocaleDateString()} and any date` })
            } else if (!!subFilters[key][1]) {
                array.push({ [key]: `Between any date and ${(subFilters[key][1]).toLocaleDateString()}` })
            }
        }
    })
    return array;
}

/**
 * Formats number of bytes
 *
 * @param  {Number} bytes: the value to format
 * @param  {Number} decimals: number to specify significant digits
 * @return {String}
 */
export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Converts dataURI to Blob
 *
 * @param  {dataURI} dataURI: the dataURI
 * @return {Blob}
 */
export const dataURItoBlob = (dataURI) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });

    return blob;

  
}

export const formatAsProperName = text => {
  const allLowerList = ['and', 'of', 'by', 'for', 'at', 'the', 'on', 'fka'];
  const allUpperList = ['ii', 'iii', 'iv', 'vi', 'vii', 'llc', 'inc', 'mlk'];
  return text.toLowerCase()
    .split(' ')
    .map((str, i) => 
      allLowerList.includes(str) && i > 0
        ? str
        : allUpperList.includes(str) 
          ? str.toUpperCase() 
          : str.charAt(0).toUpperCase() + str.substring(1)
    )
    .join(' ');
}
